'use client'

import { useEffect, useRef } from 'react'

import { cn } from '@/core/utils/common'

import {
  cardSize,
  paintExcerpt,
  prepareExcerpt,
} from '@/features/veluvit/components/reader/excerpt-canvas'

import type { ExcerptCard } from '@/features/veluvit/components/reader/excerpt-canvas'

/** 미리보기 해상도 — 화면에선 줄여 보이므로 저장(1080)보다 작게 그린다 */
const PREVIEW_WIDTH = 720

/**
 * 발췌 카드 미리보기 — 저장 PNG 와 같은 그리기 함수(paintExcerpt)로 그린다. 보이는 그대로 저장된다.
 * card 는 쓰는 쪽이 useMemo 로 묶어 넘긴다(바뀔 때만 다시 그린다). 늦게 끝난 옛 그리기는 버린다.
 * 칸 안에 비율대로 들어가게(object-contain) 그리고, 그림자는 그려진 카드 모양을 따라간다.
 */
export default function ExcerptPreview({
  card,
  className,
}: {
  card: ExcerptCard
  className?: string
}) {
  const ref = useRef<HTMLCanvasElement>(null)
  useEffect(() => {
    let alive = true
    void prepareExcerpt(card).then((assets) => {
      if (alive && ref.current)
        paintExcerpt(ref.current, card, assets, PREVIEW_WIDTH)
    })
    return () => {
      alive = false
    }
  }, [card])
  const { w, h } = cardSize(card.style.ratio, PREVIEW_WIDTH)
  return (
    <canvas
      ref={ref}
      width={w}
      height={h}
      role="img"
      aria-label={`${card.charName} 발췌 카드 미리보기: ${card.paragraphs
        .map((p) => p.text)
        .join(' ')
        .slice(0, 80)}`}
      className={cn(
        'block size-full object-contain [filter:drop-shadow(0_18px_36px_rgb(0_0_0/0.55))]',
        className
      )}
    />
  )
}
